import { Chapter } from '@/types/types';
import { Mission } from '@edwin-group/cj-graphql';

export class FindNextChapterUseCase {
  static execute(mission: Mission, currentChapter: Chapter) {
    if (!mission.chapters || !mission.chapters.length || !currentChapter)
      return { next: null, isLastChapter: false, isFirstChapter: true };

    const currentChapterPosition = mission.chapters.findIndex((chapter) => chapter?.uuid === currentChapter.uuid);
    const totalChapters = mission.chapters.length;
    const isLastChapter = currentChapterPosition === totalChapters - 1;
    const isFirstChapter = currentChapterPosition === 0;

    if (isLastChapter) return { next: null, isLastChapter: true, isFirstChapter: false };

    return { next: mission.chapters[currentChapterPosition + 1], isLastChapter, isFirstChapter };
  }
}
